<template>
  <div
    class="wrapper"
    :class="{ 'nav-open': $sidebar.showSidebar }">
    <notifications />
    <sidebar-fixed-toggle-button />
    <side-bar
      :background-color="sidebarBackground"
      :short-title="sidebarShortTitle"
      :title="sidebarTitle">
      <template slot="links">
        <sidebar-item
          v-for="link in sidebarLinks"
          :key="link.path"
          :link="{
            name: link.name,
            icon: link.icon,
            path: link.path
        }" />
      </template>
    </side-bar>
    <div
      class="main-panel"
      :data="sidebarBackground">
      <dashboard-navbar
        :me="me"
        @logout="logout" />
      <router-view name="header" />
      <div
        id="content"
        class="content">
        <zoom-center-transition
          :duration="200"
          mode="out-in"
          @after-leave="$root.$emit('triggerScroll')">
          <router-view />
        </zoom-center-transition>
      </div>
      <content-footer
        v-if="showFooter"
        :footer-website="footerWebsite"
        :footer-company="footerCompany"
        :footer-year="footerYear" />
    </div>
    <slot />
  </div>
</template>
<script>
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';
import { SlideYDownTransition, ZoomCenterTransition } from 'vue2-transitions';

import ContentFooter from 'src/components/ContentFooter.vue';
import DashboardNavbar from './DashboardNavbar.vue';
import SidebarFixedToggleButton from './SidebarFixedToggleButton.vue';

function initScrollbar(className) {
  if (document.getElementsByClassName(className).length > 0) {
    /* eslint-disable-next-line no-new */
    return new PerfectScrollbar(`.${className}`);
  }
  // try to init it later in case this component is loaded async
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(initScrollbar(className));
    }, 100);
  });
}

export default {
  name: 'DashboardLayout',
  components: {
    DashboardNavbar,
    ContentFooter,
    SidebarFixedToggleButton,
    SlideYDownTransition,
    ZoomCenterTransition,
  },
  props: {
    me: {
      type: Object,
      required: true,
    },
    sidebarLinks: {
      type: Array,
      required: true,
    },
    showFooter: {
      type: Boolean,
      default: false,
    },
    sidebarBackground: {
      type: String,
      required: true,
    },
    sidebarTitle: {
      type: String,
      required: true,
    },
    sidebarShortTitle: {
      type: String,
      required: true,
    },
    footerWebsite: {
      type: String,
      required: true,
    },
    footerCompany: {
      type: String,
      required: true,
    },
    footerYear: {
      type: String,
      required: true,
    },
  },
  mounted() {
    this.createScrollbar();
  },
  methods: {
    logout() {
      this.$emit('logout');
    },
    createScrollbar() {
      const docClasses = document.body.classList;
      const isWindows = navigator.platform.startsWith('Win');
      if (isWindows) {
        // if we are on windows OS we activate the perfectScrollbar function
        initScrollbar('sidebar');
        const ps = initScrollbar('main-panel');
        this.$store.commit('setPerfectScroll', ps);
        initScrollbar('sidebar-wrapper');
        docClasses.add('perfect-scrollbar-on');
      } else {
        docClasses.add('perfect-scrollbar-off');
      }
    },
  },
};
</script>
<style lang="scss">
  $scaleSize: 0.95;
  @keyframes zoomIn95 {
    from {
      opacity: 0;
      transform: scale3d($scaleSize, $scaleSize, $scaleSize);
    }
    to {
      opacity: 1;
    }
  }

  .main-panel .zoomIn {
    animation-name: zoomIn95;
  }

  @keyframes zoomOut95 {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
      transform: scale3d($scaleSize, $scaleSize, $scaleSize);
    }
  }

  .main-panel .zoomOut {
    animation-name: zoomOut95;
  }
</style>
